var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSexSecretHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSexSecretHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-705.000000, -4124.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sex-Story",
    transform: "translate(28.000000, 3942.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(7.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9185702,2.78372093 C19.9032951,4.57928118 21,6.96131078 21,9.5 C21,12.0386892 19.9077352,14.4207188 17.9230103,16.2162791 C15.8983244,18.0479915 13.2076234,19 10.4902818,19 C8.79860345,19 7.09360481,18.630444 5.53512948,17.8712474 C4.13649778,18.7830867 2.76894679,18.9799154 1.84096575,18.9799154 C1.4946379,18.9799154 1.21047146,18.951797 1.01066693,18.9236786 C0.584417272,18.8634249 0.255849825,18.5621564 0.189248316,18.1765328 C0.122646806,17.7909091 0.340211737,17.4173362 0.726500493,17.2446089 C1.53015871,16.8871036 2.07185099,16.172093 2.40929863,15.5575053 C-1.03177936,11.8097252 -0.765373321,6.25433404 3.07087363,2.78372093 C5.05559861,0.988160677 7.68857829,0 10.4947219,0 C13.3008655,0 15.9338452,0.988160677 17.9185702,2.78372093 Z M7.55,12 L5.782,9.6535 L7.511,7.372 L6.328,7.372 L5.21,8.9125 L4.105,7.372 L2.922,7.372 L4.6315,9.6535 L2.87,12 L4.053,12 L5.21,10.401 L6.367,12 L7.55,12 Z M12.9050715,12 L11.1370715,9.6535 L12.8660715,7.372 L11.6830715,7.372 L10.5650715,8.9125 L9.4600715,7.372 L8.2770715,7.372 L9.9865715,9.6535 L8.2250715,12 L9.4080715,12 L10.5650715,10.401 L11.7220715,12 L12.9050715,12 Z M18.260143,12 L16.492143,9.6535 L18.221143,7.372 L17.038143,7.372 L15.920143,8.9125 L14.815143,7.372 L13.632143,7.372 L15.341643,9.6535 L13.580143,12 L14.763143,12 L15.920143,10.401 L17.077143,12 L18.260143,12 Z",
    id: "icSexSecretHS"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSexSecretHs);
export default __webpack_public_path__ + "static/media/icSexSecretHS.6933cdfd745ca110f621e9a838626ad6.svg";
export { ForwardRef as ReactComponent };